import React from "react";
import PropTypes from "prop-types";

import arrow from "assets/graphics/icons/arrow.png";

import "features/new/carousel/view.scss";

const CarouselView = ({
  itemImages,
  activeItemIndex,
  carouselPosition,
  isTransitioned,
  references,
  goToPreviousItem,
  goToNextItem,
  setSwipePosition,
  swipe,
}) => (
  <div className="main__carousel" ref={references.carouselContainer}>
    <div
      className="carousel__items"
      style={{
        transform: `translateX(${carouselPosition}px)`,
        transitionDuration: isTransitioned ? "0.4s" : "0s",
      }}
    >
      {itemImages.map((item, index) => (
        <img
          className={`carousel__item${
            index === activeItemIndex ? "--active" : ""
          }`}
          style={{ transitionDuration: isTransitioned ? "0.4s" : "0s" }}
          src={item.image}
          alt={item.alternate}
          key={index}
          ref={
            index === activeItemIndex
              ? references.carouselItemActive
              : index === 0
              ? references.carouselItem
              : undefined
          }
          onDragStart={(event) => event.preventDefault()}
          onTouchStart={setSwipePosition}
          onTouchMove={swipe}
          onClick={
            index === activeItemIndex - 1 || index === activeItemIndex - 2
              ? goToPreviousItem
              : index === activeItemIndex + 1 || index === activeItemIndex + 2
              ? goToNextItem
              : undefined
          }
        />
      ))}
    </div>
    <div className="carousel__controls">
      <img
        className="carousel__control"
        src={arrow}
        alt="arrow"
        onClick={goToPreviousItem}
      />
      <img
        className="carousel__control"
        src={arrow}
        alt="arrow"
        onClick={goToNextItem}
      />
    </div>
  </div>
);

CarouselView.propTypes = {
  itemImages: PropTypes.array,
  activeItemIndex: PropTypes.number,
  carouselPosition: PropTypes.number,
  isTransitioned: PropTypes.bool,
  references: PropTypes.object,
  goToPreviousItem: PropTypes.func,
  goToNextItem: PropTypes.func,
  setSwipePosition: PropTypes.func,
  swipe: PropTypes.func,
};

export default CarouselView;
